import { Component, OnInit } from '@angular/core';
import { ControlContainer, FormGroupDirective, UntypedFormControl, Validators } from '@angular/forms';
import { ButtonStepComponent } from '../../step/button-step/button-step.component';

@Component({
    selector: 'app-first-time-buyer',
    templateUrl: '../../step/button-step/button-step.component.html',
    styleUrls: ['../../step/step.component.scss', '../../step/button-step/button-step.component.scss'],
    viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
    standalone: false
})
export class FirstTimeBuyerComponent extends ButtonStepComponent implements OnInit {
  title : string = "Are you a first time home buyer?";
  buttonList = [
    { text: 'No', value: 'no', imageName: 'no-x', default: true},
    { text: 'Yes', value: 'yes', imageName: 'yes' },
  ];
  ngOnInit() {
    this.control = this.form.contains('firstTimeBuyer')
      ? this.form.get('firstTimeBuyer') as UntypedFormControl
      : new UntypedFormControl('');
    this.control.setValidators(Validators.required);
    this.control.updateValueAndValidity();
    if (!this.form.contains('firstTimeBuyer')) { this.form.addControl('firstTimeBuyer', this.control); }
  }

}
